import type { StoreCard as StoreCardType } from "@/types/content";
import StoreCard from "@/components/base/StoreCard";

interface Props {
  section: {
    _type: "relatedStores";
    _key: string;
    title?: string;
    stores: StoreCardType[];
  };
}


export default function RelatedStoresSectionBlock({ section }: Props) {
  if (!section.stores || section.stores.length === 0) return null;

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16 bg-white">
      <div className="max-w-6xl mx-auto">
        {section.title && (
          <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-8">
            {section.title}
          </h2>
        )}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {section.stores.map((store) => (
            <StoreCard
              key={store.id}
              store={store}
              padding="compact"
              tags={
                store.tags.includes("文化幣") && (
                  <span className="px-2.5 py-1 bg-emerald-500/90 backdrop-blur-sm rounded-full text-xs font-medium text-white">
                    文化幣
                  </span>
                )
              }
              footer={
                <>
                  <p className="text-xs text-slate-500 line-clamp-2 mb-3">
                    {store.description}
                  </p>
                  <div className="flex items-center justify-between text-xs text-slate-400">
                    <div className="flex items-center gap-1">
                      <i className="ri-star-fill text-amber-400" />
                      <span className="text-slate-600 font-medium">{store.rating}</span>
                      <span>({store.reviewCount})</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-1 mt-2 text-xs text-slate-400">
                    <i className="ri-map-pin-line" />
                    <span className="line-clamp-1">{store.location}</span>
                  </div>
                </>
              }
            />
          ))}
        </div>
      </div>
    </section>
  );
}